import { render, staticRenderFns } from "./recyclePic.vue?vue&type=template&id=3d076aa3&scoped=true&"
import script from "./recyclePic.vue?vue&type=script&lang=js&"
export * from "./recyclePic.vue?vue&type=script&lang=js&"
import style0 from "./recyclePic.vue?vue&type=style&index=0&id=3d076aa3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d076aa3",
  null
  
)

export default component.exports